export default __webpack_public_path__ + "static/media/r2.ae487e48.jpg";